<template>
    <!-- Page Content Wrapper -->
    <div id="page-content-wrapper" class="admin-content-area">
        <div class="container-fluid xyz">
            <div class="page-header-top-container">
                <div id="benefitHeader" class="page-name">{{pageTitle}}</div>
                <button type="submit" class="back_button btn btn-primary pull-right" v-on:click.prevent="buttonBack">Back</button>
            </div>
            <!--page content-->
            <div class="admin-page-content">
                <form id="changeProfile">
                    <div class="forms-container">
                        <div class="row no-margin">
                            <!--Category-->
                            <div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="categories">Category :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <v-select v-model="categoryId"
                                              @change="changedValue"
                                              @input="changedCategoryFor()"
                                              name="categoryId"
                                              id="categoryId"
                                              label="text"
                                              :filterable="false"
                                              :options="categoryArr"
                                              @search="onSearchCategory"
                                              placeholder="Select Category">
                                        <template slot="no-options">
                                            Search Category...
                                        </template>
                                        <template slot="option" slot-scope="option">
                                            <div class="d-center">
                                                {{ option.text }}
                                            </div>
                                        </template>
                                        <template slot="selected-option" slot-scope="option">
                                            <div class="selected d-center">
                                                {{ option.text }}
                                            </div>
                                        </template>
                                    </v-select>
                                    <div class="requiredstar">*</div>
                                    <font class="text-danger">{{categoryError}}</font>
                                </div>
                            </div>
                            <!--Location-->
                            <!--<div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="locationId">State :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <v-select v-model="locationId"
                                              @change="changedValue"
                                              @input="changedValueLocation()"
                                              name="locationId"
                                              id="locationId"
                                              label="text"
                                              :filterable="false"
                                              :options="locationArr"
                                              @search="onSearchLocation"
                                              placeholder="Select State">
                                        <template slot="no-options">
                                            Search State...
                                        </template>
                                        <template slot="option" slot-scope="option">
                                            <div class="d-center">
                                                {{ option.text }}
                                            </div>
                                        </template>
                                        <template slot="selected-option" slot-scope="option">
                                            <div class="selected d-center">
                                                {{ option.text }}
                                            </div>
                                        </template>
                                    </v-select>
                                    <font class="text-danger">{{locationError}}</font>
                                </div>
                            </div>-->
                            <!--Role-->
                            <!--<div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="roleId">Role :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <v-select class=""
                                              v-model="roleId"
                                              @input="changedValueRole()"
                                              name="roleId"
                                              id="roleData"
                                              label="text"
                                              :searchable="false"
                                              :filterable="false"
                                              :options="roleArr"
                                              placeholder="Select Category">
                                        <template slot="no-options">
                                            Search Role...
                                        </template>
                                        <template slot="option" slot-scope="option">
                                            <div class="d-center">
                                                {{ option.text }}
                                            </div>
                                        </template>
                                        <template slot="selected-option" slot-scope="option">
                                            <div class="selected d-center">
                                                {{ option.text }}
                                            </div>
                                        </template>
                                    </v-select>
                                    <font class="text-danger">{{roleError}}</font>
                                </div>
                            </div>-->

                            <!--Status-->
                            <div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="status">Status :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <v-select v-model="status"
                                              @input="changedStatus()"
                                              name="status"
                                              id="status"
                                              label="text"
                                              :filterable="false"
                                              :options="statusArr"
                                              placeholder="Select Status">
                                    </v-select>
                                    <font class="text-danger">{{statusError}}</font>
                                </div>
                            </div>
                            <!--Video Title-->
                            <div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="videoTitle">Video Title :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <input v-model="videoTitle" type="text" class="form-control" id="videoTitle" placeholder="Video Title">
                                    <font class="text-danger">{{videoTitleError}}</font>
                                </div>
                            </div>
                            <!--Video-->
                            <!--<div class="clearfix"></div>-->
                            <!--<div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">-->
                            <!--<template>-->
                            <!--<div id="app">-->
                            <!--<label for="videoTitle">Upload Video</label>-->
                            <!--<vue-dropzone-->
                            <!--id="drop1"-->
                            <!--:options="dropzoneOptions"-->
                            <!--ref="dropzone"-->
                            <!--:destroyDropzone="false"-->
                            <!--:headers="dropzoneOptions.headers"-->
                            <!--@vdropzone-removed-file="removedSelectedFile"-->
                            <!--@vdropzone-success="vfileSuccess"-->
                            <!--@vdropzone-duplicate-file="vduplicateFile"-->
                            <!--name="file"-->
                            <!--&gt;-->
                            <!--</vue-dropzone>-->
                            <!--<font class="text-danger"> <strong id="errorMsg1" class="error text-danger"></strong></font>-->
                            <!--</div>-->
                            <!--</template>-->
                            <!--</div>-->

                            <!--Description-->
                            <div class="col-12 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="description">Description :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <textarea v-model="description" class="form-control" id="description" placeholder="Description"></textarea>
                                    <div class="requiredstar">*</div>
                                    <font class="text-danger">{{descriptionError}}</font>
                                </div>
                            </div>
                            <!--Video-->
                            <div id="myRadioGroup" class="col-12"   >
                                <div class="row col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                    <span id="myForm">
                                        <label><input id="uploadManually" type="radio" name="cars" value="2" checked="checked"/>Enter Manually</label>
                                        <label><input id="vodepUrl" type="radio" name="cars" value="3">Enter Video URL</label>
                                    </span>
                                </div>
                                <br/>
                                <br/>
                                <!--Enter Manually-->
                                <div id="Cars2" class="row desc">
                                    <div class="col-12 forms-block">
                                        <div class="col-3 paddingleft0">
                                            <div class="form-label" for="drop1">Upload Video :</div>
                                        </div>
                                        <div class="col-9 paddingleft0">
                                            <vue-dropzone
                                                id="drop1"
                                                :options="dropzoneOptions"
                                                ref="dropzone"
                                                :destroyDropzone="false"
                                                :headers="dropzoneOptions.headers"
                                                @vdropzone-removed-file="removedSelectedFile"
                                                @vdropzone-success="vfileSuccess"
                                                @vdropzone-duplicate-file="vduplicateFile"
                                                @vdropzone-total-upload-progress="progressOfUload"
                                                name="file"
                                                >
                                            </vue-dropzone>
                                            <font class="text-danger">{{videoURLError}}</font>
                                            <font class="text-danger"> <strong id="errorMsg2" class="error text-danger"></strong></font>
                                        </div>
                                    </div>
                                </div>

                                <!--Enter Video URL-->
                                <div class="clearfix"></div>
                                <div div id="Cars3" class="desc" style="display: none;">
                                    <div class="col-12 forms-block">
                                        <div class="col-3 paddingleft0">
                                            <div class="form-label" for="videoURL">Video URL :</div>
                                        </div>
                                        <div class="col-9 paddingleft0">
                                            <input v-model="videoURL" type="text" class="form-control" id="videoURL" placeholder="Video URL">
                                            <font class="text-danger">{{videoURLError}}</font>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!--Error Alert-->
                            <div class="col-12">
                                <div class="col-12 paddingleft0">
                                    <div class="alert alert-danger" id="alertError">
                                        <!--<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>-->
                                        <strong id="errorMsg" class="error"></strong>
                                    </div>
                                </div>
                            </div>
                            <!--Buttons-->
                            <div class="col-12">
                                <div class="col-12 paddingleft0">
                                    <input id="addBenifitBtn" type="submit" value="Save" class="btn btn-primary" v-on:click.prevent="addDayforce101()">
                                    <input id="addAndContinueBenifitBtn" type="submit" value="Save and Continue" class="btn btn-primary" v-on:click.prevent="addDayforce101(flag='Save and Continue')">
                                    <!--<input id="addMedia" type="submit" value="Save" class="btn btn-primary" v-on:click.prevent="addDayforce101()"></input>-->
                                    <input id="CancelBenifit" type="submit" value="Cancel" class="back_button btn btn-primary" v-on:click.prevent="buttonBack">
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--page content-->
                </form>
            </div>
        </div>
        <app-backend-footer></app-backend-footer>
    </div>
    <!-- /#page-content-wrapper -->
</template>

<script>
    var self;
    import vSelect from 'vue-select';
    import Vue from 'vue';
    import BackendFooter from '@/components/backend/partials/Footer';
    import SessioMixin from '../../../mixins/sessionmixin';
    import { HTTP } from '../../../http-common';
    import moment from 'moment';
    import VueCroppie from 'vue-croppie';
    import vue2Dropzone from 'vue2-dropzone';
    import 'vue2-dropzone/dist/vue2Dropzone.min.css';
    import tinymce from 'vue-tinymce-editor';
    import axios from 'axios';

    Vue.use(VueCroppie);
    export default {
        name: 'Login',
        props: [''],
        mixins: [SessioMixin],
        components: {
            'v-select': vSelect,
            vueDropzone: vue2Dropzone,
            'tinymce': tinymce,
            'app-backend-footer': BackendFooter,
        },
        data() {
            return {
                //DropZone
                dropzoneOptions: {
                    timeout: 3000000,
                    url: process.env.ROOT_API + "/uploadmedia",
                    method: 'POST',
                    paramName: 'file',
                    autoProcessQueue: true,
                    maxFilesize: 150, //MB
                    maxFiles: 1, //ToDo : to decide number of files allowed
                    thumbnailWidth: 150, // px
                    thumbnailHeight: 150,
                    addRemoveLinks: true,
                    duplicateCheck: true,
                    acceptedFiles: ".mp4",
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("api_token"),
                        // 'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, DELETE',
                        // 'Access-Control-Allow-Headers': 'Content-Type, Authorization, X-Requested-With',//'Origin, X-Requested-With, Content-Type, Accept, X-File-Name, X-File-Size, X-File-Type',
                        //'Content-Type': 'application/x-www-form-urlencoded'
                    },
                    dictFileTooBig: "File is too big ({{filesize}}mb). Max allowed file size is {{maxFilesize}}mb",
                    dictInvalidFileType: "Invalid File Type",
                    dictCancelUpload: "Cancel",
                    dictRemoveFile: "Remove",
                    dictMaxFilesExceeded: "Only {{maxFiles}} file is allowed",
                    dictDefaultMessage: "Drop files here to upload",
                },

                videoType: '',
                videoSize: '',
                videoPaths: '',
                mediaThumbnailPaths: '',
                videoURL: '',
//                V-model
                categoryId: '',
                categoryArr: [],
                locationId: '',
                locationArr: [],
                roleId: 0,
                roleArr: [],
                status: {value: 'active', text: 'Active'},
                statusArr: [
                    {value: 'active', text: 'Active'},
                    {value: 'inactive', text: 'Inactive'}
                ],
                videoTitle: '',
                selectedRadioButton: '',
                pageTitle: 'Add Dayforce 101',
                description: '',

//                FrontEnd Errors
                categoryError: '',
                locationError: '',
                statusError: '',
                videoTitleError: '',
                videoURLError: '',
                roleError: '',
                isFileUploaded: false,
                isVideoLoaded: false,
                descriptionError: '',

//                BackEnd Error
                backendErrors: [],
                fileUploaded: true,
            }
        },
        mounted: function () {
            self = this;
            self.checkLogin();
            self.loadCategoryFirst();
            /*self.loadCategory();*/
            self.loadLocationsAdd();
            /*self.loadRole();
             self.loadLocations();*/

            var path = window.location.pathname;
            var segments = path.split("/");

            if (segments[2] == 'updatedayforce101') {
                if (segments[3]) {
                    self.loadDayforce101();
                    $("#addAndContinueBenifitBtn").hide();
                    $("#addBenifitBtn").val("Update");
                    self.pageTitle = "Edit Dayforce 101";
                }
            } else {
                self.selectedRadioButton = 2;
            }

            $(document).ready(function () {
                $("input[name$='cars']").click(function () {
                    var test = $(this).val();

                    $("div.desc").hide();
                    $("#Cars" + test).show();
                    self.videoURLError = "";
                });
            });

            $('#myForm input').on('change', function () {
                var selectedRadioButton = $('input[name=cars]:checked', '#myForm').val();
                self.selectedRadioButton = selectedRadioButton;
                if (self.selectedRadioButton == 3) {
                    self.removeAllFiles();
                    self.videoPaths = '';
                    self.mediaThumbnailPaths = '';
                    self.isFileUploaded = true;
                }
            });
//            if (segments[2] == 'adddayforce101') {
//                self.selectedRadioButton = 3;
//                $('input:radio[name="cars"]').filter('[value="3"]').attr('checked', true);
//                $("#Cars2").hide();
//                $("#Cars3").show();
//                $(function () {
//                    /*console.log("in function");*/
//                    var $radios = $('input:radio[name=cars]');
//                    if ($radios.is(':checked') === false) {
//                        $radios.filter('[value=3]').prop('checked', true);
//                    }
//                });
//            }

            $("#locationId").on('keyup', function () {
                self.locationError = '';
            });
            $("#categoryId").on('keyup', function () {
                self.categoryError = '';
            });
            $("#roleId").on('keyup', function () {
                self.roleError = '';
            });
            $("#videoURL").on('keyup', function () {
                self.videoURLError = '';
            });
            $("#videoTitle").on('keyup', function () {
                self.videoTitleError = '';
            });
            $("#description").on('keyup', function () {
                self.descriptionError = '';
            });

            $("#drop1").on('change', function () {
                self.videoURLError = '';
            });

            $("#alertError").hide();
            $('#main-header').hide();
            $('#main-footer').hide();
            $('html,body,#app').css({
                //height: "100%"
            });
            /*if ($(".login-form-right-section").height() > $(window).height()) {
             $("#login-main-hr").height($(".login-form-right-section").height());
             } else {*/
            $("#login-main-hr").height($(window).height());
            /*}*/
            /*$("#login-main-hr").css({
             height:
             });*/

        },
        watch: {

        },
        methods: {
            buttonBack() {
                $(".back_button").prop("disabled", false);
                self.$router.push('/backend/listdayforce101');
            },

            removeAllFiles() {
                self.$refs.dropzone.removeAllFiles();
            },

            vfileSuccess: function (file, response) {
                self.videoPaths = response.content.media_path;
                self.isFileUploaded = true;
                if ("media_thumb_path" in response.content) {
                    self.mediaThumbnailPaths = response.content.media_thumb_path;
                } else {
                    self.mediaThumbnailPaths.push("");
                    /*console.log("No media thumb");*/
                }
                self.videoType = file.type;
                self.videoSize = file.size;
                self.videoURLError = '';
            },

            removedSelectedFile(file, xhr, error) {
                self.isFileUploaded = false;
                self.isVideoLoaded = false;
                var filePath = JSON.parse(file.xhr.response);
                //console.log(file);
                if ("media_thumb_path" in filePath.content) {
                    //self.mediaThumbnailPaths.pop(filePath.content.media_thumb_path);
                    self.removeFileFromServer(filePath.content.media_path, filePath.content.media_thumb_path);
                } else {
                    //self.mediaThumbnailPaths.pop(filePath.content.media_thumb_path);
                    self.removeFileFromServer(filePath.content.media_path, "");
                }
//                for (var i = self.videoPaths.length - 1; i >= 0; i--) {
//                    if (self.videoPaths[i] === filePath.content.media_path) {
//                        self.videoPaths.splice(i, 1);
//                        self.videoType.splice(i, 1);
//                        self.videoSize.splice(i, 1);
//                        self.mediaThumbnailPaths.splice(i, 1);
//                        // break;       //<-- Uncomment  if only the first term has to be removed
//                    }
//                }
            },
            changedStatus() {
                self.statusError = '';
            },
            removeFileFromServer: function (filePath, thumbnailPath) {
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                    data: {
                        filePath: filePath,
                        thumbnailPath: thumbnailPath
                    }
                };
                HTTP.delete('removemedia', config)
                        .then(function (response) {
                            /*console.log("File removed successfully");*/
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                                self.error = err.response.data.message;
                            }
                        });
            },
            vduplicateFile: function (file) { // Todo: Understand functionality. Not Working till date.
                /*console.log("Duplicate file" + file.name);*/
            },

            /*changedValue: function (value) {
             //console.log(value);
             },*/

            loadCategoryFirst() {
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                    params: {
                        'type': 'dayforce',
                    }
                };
                HTTP.get("getcategory", config)
                        .then(function (response) {
                            self.categoryArr = response.data.content;
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                                self.error = err.response.data.message;
                            }
                        });
            },
            changedValue: function (value) {
                //console.log(value);
            },
            changedCategoryFor: function () {
                self.categoryError = '';
            },
            onSearchCategory(search, loading) {
                if (search.length >= 2) {
                    if (typeof (loading) != "undefined") {loading(true);}
                    this.loadCategory(loading, search, this);
                }
            },
            loadCategory(loading, search, vm) {
                search = (search === null || typeof (search) === "undefined" || search == '') ? '' : search;
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                    params: {
                        'type': 'dayforce',
                        'search': search,
                    }

                };
                HTTP.get("getcategory", config)
                        .then(function (response) {
                            self.categoryArr = response.data.content;
                            if (typeof (loading) != "undefined") {
                                loading(false);
                            }
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                                self.error = err.response.data.message;
                            }
                        });
            },

            loadLocationsAdd(loading, search, vm) {
                search = (search === null || typeof (search) === "undefined" || search == '') ? '' : search;
                var data = {
                    search: search
                };
                HTTP.post("getlocation", data)
                        .then(function (response) {
                            self.locationArr = response.data.content;
                            if (typeof (loading) != "undefined") {
                                loading(false);
                            }
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                                self.error = err.response.data.message;
                            }
                        });
            },
            changedValueLocation: function () {
                self.locationError = "";
            },
            onSearchLocation(search, loading) {
                if (search.length > 2) {
                    if (typeof (loading) != "undefined") {loading(true);}
                    this.loadLocationsAdd(loading, search, this);
                }
            },

            loadRole() {
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                };
                HTTP.post("getroles", '', config)
                        .then(function (response) {
                            self.roleArr = [];
                            $.each(response.data.content, function (i) {
                                self.roleArr.push(response.data.content[i]);
                            });
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                            }
                        });
            },
            changedValueRole() {
                self.roleError = '';
            },

            loadLocations() {
                HTTP.post("/getlocation")
                        .then(function (response) {
                            self.locationArr = response.data.content;
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                                self.error = err.response.data.message;
                            }
                        });
            },

            checkForm: function () {
                var checked = true;
                /*console.log(self.selectedRadioButton);*/
                if (self.selectedRadioButton == 2) {
                    if (!self.videoPaths) {
                        /*console.log("Upload Error");*/
                        self.videoURLError = "Please Upload Video";
                        if (checked) {
                            checked = false;
                        }
                    }
                }
                if (self.selectedRadioButton == 3) {
                    if (!self.videoURL) {
                        self.videoURLError = "Please Enter Video URL";
                        if (checked) {
                            checked = false;
                        }
                    } else if (!self.validUrl(self.videoURL)) {
                        self.videoURLError = 'Please Enter Valid URL';
                        if (checked) {
                            checked = false;
                        }
                    }
                }
                if (!self.categoryId) {
                    /*console.log("Category Required");*/
                    self.categoryError = "Category Required";
                    if (checked) {
                        checked = false;
                    }
                }
                if (!self.description) {
                    self.descriptionError = "Description Required";
                    if (checked) {
                        checked = false;
                    }
                }
                if (!self.status) {
                    /*console.log("Status Required");*/
                    self.statusError = "Status Required";
                    if (checked) {
                        checked = false;
                    }
                }
                if (!self.videoTitle) {
                    /*console.log("Video Title Required");*/
                    self.videoTitleError = "Video Title Required";
                    if (checked) {
                        checked = false;
                    }
                }
                if (self.fileUploaded == false) {
                    self.videoURLError = "Please Wait While Video Is Being Uploaded";
                    if (checked) {
                        checked = false;
                    }
                }

                return checked;
            },

            validUrl: function (url) {
                var re = /^(http[s]?:\/\/){0,1}(www\.){0,1}[a-zA-Z0-9\.\-]+\.[a-zA-Z]{2,5}[\.]{0,1}/;
                return re.test(url);
            },

            loadDayforce101() {
                var path = window.location.pathname;
                var segments = path.split("/");
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                };

                var data = {
                    id: segments[3],
                };
                self.showLoader();
                HTTP.post("getdayforce101/" + segments[3], data, config)
                        .then(function (response) {
//                        self.locationId = response.data.content[0].location_name;
//                        self.locationId = {
//                            value: response.data.content[0].location_id,
//                            text: response.data.content[0].location_name,
//                        };
                            self.status = {
                                value: response.data.content[0].status,
                                text: self.formatString(response.data.content[0].status),
                            };
                            self.categoryId = {
                                value: response.data.content[0].category_id,
                                text: response.data.content[0].category_name,
                            };
//                        self.roleId = {
//                            value: response.data.content[0].role_id,
//                            text: response.data.content[0].role_name,
//                        };
                            self.description = response.data.content[0].description;
                            self.videoPaths = response.data.content[0].video_path;
                            self.videoTitle = response.data.content[0].video_title;
                            self.videoURL = response.data.content[0].video_url;
                            var uploadedType = response.data.content[0].uploaded_type;

                            /*console.log(self.videoTitle);*/

                            if (uploadedType == 'upload') {
                                self.selectedRadioButton = 2;
                                self.isFileUploaded = true;
                                self.isVideoLoaded = true;
                                self.videoSize = response.data.content[0].video_size;
                                self.uploadManually();
                            }
                            if (uploadedType == 'url') {
                                self.selectedRadioButton = 3;
                                self.isFileUploaded = true;
                                /*console.log("in if");*/
                                $('input:radio[name="cars"]').filter('[value="3"]').attr('checked', true);
                                $("#Cars2").hide();
                                $("#Cars3").show();
                                $(function () {
                                    /*console.log("in function");*/
                                    var $radios = $('input:radio[name=cars]');
                                    if ($radios.is(':checked') === false) {
                                        $radios.filter('[value=3]').prop('checked', true);
                                    }
                                });
                            }
                            self.hideLoader();
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                                self.error = err.response.data.message;
                            }
                            self.hideLoader();
                        });
            },

            uploadManually(file) {
                if (self.videoPaths != '') {
                    var file_name = self.getFileName(self.videoPaths);
                    let file_type = self.getFileType(file_name);
                    let url = self.videoPaths;
                    let file_size = self.videoSize;
                    /*console.log("File Name : " + file_name + " , File Type : " + file_type + " , URL : " + url + " , File Size : " + file_size);*/
                    let file_data = {size: file_size, fileid: file_name, name: file_name, type: file_type};
                    self.$refs.dropzone.manuallyAddFile(file_data, url);
                    /*
                     self.truckFormData.uploadedFiles.push(file_name);*/
                }

            },

            getFileName: function (file) {
                var src = file.split('/');
                var file_name = src[src.length - 1];
                return file_name;
            },
            getFileType: function (file_name) {
                var type = file_name.split('.');
                var file_type = type[type.length - 1];
                // return 'image/' + file_type;
                return 'video/' + file_type;
            },

            addDayforce101(flag) {
                /*console.log("Befor form check");*/
                self.checkForm();
                if (self.checkForm()) {
                    /*console.log("form check success");*/
                    var path = window.location.pathname;
                    var segments = path.split("/");
                    var config = {
                        headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                    };

                    if (segments[2] == 'updatedayforce101') {
                        if (segments[3]) {
                            if (self.isVideoLoaded == true) {
                                self.videoPaths = '';
                            }
                            var data = {
                                categoryId: self.categoryId.value,
                                /*roleId: self.roleId.value,
                                 locationId: self.locationId.value,*/
                                videoTitle: self.videoTitle,
                                status: self.status.value,
                                mediaPath: self.videoPaths,
                                mediaThumbnailPaths: self.mediaThumbnailPaths,
                                mediaType: self.videoType,
                                mediaSize: self.videoSize,
                                videoURL: self.videoURL,
                                uploadedType: self.selectedRadioButton,
                                description: self.description,
                                id: segments[3],
                            };
                            $("#addBenifitBtn").val("Updating ...");
                            $("#addBenifitBtn").prop("disabled", true);
                            // $("#addAndContinueCaseBtn").prop('disabled',true);
                            $("#CancelBenifit").prop("disabled", true);
                        } else {
                            if (flag == "Save and Continue") {
                                $("#addAndContinueBenifitBtn").val("Saving ...");
                                $("#addAndContinueBenifitBtn").prop("disabled", true);
                                $("#addBenifitBtn").prop("disabled", true);
                                $("#CancelBenifit").prop("disabled", true);
                            } else {
                                $("#addBenifitBtn").val("Saving ...");
                                $("#addBenifitBtn").prop("disabled", true);
                                $("#addAndContinueBenifitBtn").prop("disabled", true);
                                $("#CancelBenifit").prop("disabled", true);
                            }
                        }
                    } else {
                        var data = {
                            categoryId: self.categoryId.value,
                            /*roleId: self.roleId.value,
                             locationId: self.locationId.value,*/
                            videoTitle: self.videoTitle,
                            status: self.status.value,
                            mediaPath: self.videoPaths,
                            mediaThumbnailPaths: self.mediaThumbnailPaths,
                            mediaType: self.videoType,
                            mediaSize: self.videoSize,
                            videoURL: self.videoURL,
                            uploadedType: self.selectedRadioButton,
                            description: self.description,
                        };
                        if (flag == "Save and Continue") {
                            $("#addAndContinueBenifitBtn").val("Saving ...");
                            $("#addAndContinueBenifitBtn").prop("disabled", true);
                            $("#addBenifitBtn").prop("disabled", true);
                            $("#CancelBenifit").prop("disabled", true);
                        } else {
                            $("#addBenifitBtn").val("Saving ...");
                            $("#addBenifitBtn").prop("disabled", true);
                            $("#addAndContinueBenifitBtn").prop("disabled", true);
                            $("#CancelBenifit").prop("disabled", true);
                        }
                    }
                    self.showLoader();
                    HTTP.post("addupdatedayforce101", data, config)
                            .then(function (response) {
                                self.removeAllFiles();
                                if (segments[2] == 'updatedayforce101') {
                                    if (segments[3]) {
                                        //console.log(segments[3]);
                                        $("#addBenifitBtn").val("Update");
                                        $("#addBenifitBtn").prop("disabled", false);
                                        // $("#addAndContinueCaseBtn").prop('disabled',true);
                                        $("#CancelBenifit").prop("disabled", false);
                                    } else {
                                        if (flag == "Save and Continue") {
                                            $("#addAndContinueBenifitBtn").val("Save and Continue");
                                            $("#addAndContinueBenifitBtn").prop("disabled", false);
                                            $("#addBenifitBtn").prop("disabled", false);
                                            $("#CancelBenifit").prop("disabled", false);
                                        } else {
                                            $("#addBenifitBtn").val("Save");
                                            $("#addBenifitBtn").prop("disabled", false);
                                            $("#addAndContinueBenifitBtn").prop("disabled", false);
                                            $("#CancelBenifit").prop("disabled", false);
                                        }
                                    }
                                } else {
                                    if (flag == "Save and Continue") {
                                        $("#addAndContinueBenifitBtn").val("Save and Continue");
                                        $("#addAndContinueBenifitBtn").prop("disabled", false);
                                        $("#addBenifitBtn").prop("disabled", false);
                                        $("#CancelBenifit").prop("disabled", false);
                                    } else {
                                        $("#addBenifitBtn").val("Save");
                                        $("#addBenifitBtn").prop("disabled", false);
                                        $("#addAndContinueBenifitBtn").prop("disabled", false);
                                        $("#CancelBenifit").prop("disabled", false);
                                    }
                                }

                                if (response.data.status == "success") {
                                    // self.$router.push('/task/list');
                                    $("#errorMsg").html(response.data.content);
                                    $(".alert-danger").removeClass("hide");
                                    $(".alert-danger").addClass("show");
                                    if (flag == "Save and Continue") {
//                                $("html, body").animate({scrollTop: "0px"}, 500);
                                        $(".alert-success").addClass("show");
                                        self.categoryId = '';
                                        self.categoryArr = [];
                                        /*self.locationId = '';
                                         self.locationArr = [];
                                         self.roleId = '';
                                         self.roleArr = [];*/
                                        self.videoTitle = '';
                                        self.description = '';
                                        self.videoURL = '';
                                        self.status = {value: 'active', text: 'Active'};
                                        self.loadCategoryFirst();
                                        setTimeout(function () {
                                            $(".alert-danger").removeClass("show");
                                            $(".alert-danger").addClass("hide");
                                        }, 3000);
                                    } else {
                                        $(".back_button").prop("disabled", true);
                                        setTimeout(function () {
                                            $(".alert-danger").removeClass("show");
                                            $(".alert-danger").addClass("hide");
                                            self.buttonBack();
                                        }, 3000);
                                    }
                                } else {
                                    $("#alertError").show();
                                    if (response.data.content.length > 0) {
                                        var err = "";
                                        for (var i = 0; i < response.data.content.length; i++) {
                                            err += response.data.content[i] + "<br>";
                                        }
                                        $("#errorMsg").html(err);
                                        $(".alert-danger").removeClass("hide");
                                        $(".alert-danger").addClass("show");
                                    }
                                    setTimeout(function () {
                                        $(".alert-danger").removeClass("show");
                                        $(".alert-danger").addClass("hide");
                                    }, 5000);
                                }
                                self.hideLoader();
                            })
                            .catch(function (err) {
                                self.removeAllFiles();
                                if (segments[2] == 'updatedayforce101') {
                                    if (segments[3]) {
                                        $("#addBenifitBtn").val("Update");
                                        $("#addBenifitBtn").prop("disabled", false);
                                        // $("#addAndContinueCaseBtn").prop('disabled',true);
                                        $("#CancelBenifit").prop("disabled", false);
                                        $("#errorMsg").html(err.response.data.message);
                                        $(".alert-danger").removeClass("hide");
                                        $(".alert-danger").addClass("show");
                                        setTimeout(function () {
                                            $(".alert-danger").removeClass("show");
                                            $(".alert-danger").addClass("hide");
                                        }, 5000);
                                    } else {
                                        if (flag == "Save and Continue") {
                                            $("#addAndContinueBenifitBtn").prop("disabled", false);
                                            $("#addAndContinueBenifitBtn").val("Save and Continue");
                                            $("#addBenifitBtn").prop("disabled", false);
                                            $("#CancelBenifit").prop("disabled", false);
                                            $("#errorMsg").html(err.response.data.message);
                                            $(".alert-danger").removeClass("hide");
                                            $(".alert-danger").addClass("show");
                                            $(".alert-success").removeClass("hide");
                                            $(".alert-success").addClass("show");
                                            self.removeAllFiles();
                                            self.categoryId = '';
                                            self.categoryArr = [];
                                            /*self.locationId = '';
                                             self.locationArr = [];
                                             self.roleId = '';
                                             self.roleArr = [];*/
                                            self.videoTitle = '';
                                            self.description = '';
                                            self.videoURL = '';
                                            self.status = {value: 'active', text: 'Active'};
                                            self.loadCategoryFirst();
                                            $("#status option[value='']").attr('selected', true);
                                            $("#type option[value='']").attr('selected', true);

                                            setTimeout(function () {
                                                $(".alert-danger").removeClass("show");
                                                $(".alert-danger").addClass("hide");
                                            }, 5000);
                                        } else {
                                            $("#addBenifitBtn").val("Save");
                                            $("#addBenifitBtn").prop("disabled", false);
                                            $("#addAndContinueBenifitBtn").prop("disabled", true);
                                            $("#CancelBenifit").prop("disabled", false);
                                            $("#errorMsg").html(err.response.data.message);
                                            $(".alert-danger").removeClass("hide");
                                            $(".alert-danger").addClass("show");
                                            setTimeout(function () {
                                                $(".alert-danger").removeClass("show");
                                                $(".alert-danger").addClass("hide");
                                            }, 5000);
                                        }

                                        if (err.response.status == 0) {
                                            self.errorMsg = "Remote server can not be reachable";
                                        } else {
                                            //redirect to login page if user not authenticated
                                            if (err.response.status == 401) {
                                                //clear previous data
                                                localStorage.removeItem("user_obj");
                                                localStorage.removeItem("api_token");
                                                localStorage.removeItem("profile_image");
                                                //EventBus.$emit("logged-in", true, "", "");
                                                self.$router.push("/login");
                                            }
                                            $("#errorMsg").html(err.response.data.message);
                                            $(".alert-danger").removeClass("hide");
                                            $(".alert-danger").addClass("show");
                                            setTimeout(function () {
                                                $(".alert-danger").removeClass("show");
                                                $(".alert-danger").addClass("hide");
                                            }, 5000);
                                        }
                                    }
                                } else {
                                    if (flag == "Save and Continue") {
                                        $("#addAndContinueBenifitBtn").prop("disabled", false);
                                        $("#addAndContinueBenifitBtn").val("Save and Continue");
                                        $("#addBenifitBtn").prop("disabled", false);
                                        $("#CancelBenifit").prop("disabled", false);
                                        $("#errorMsg").html(err.response.data.message);
                                        $(".alert-danger").removeClass("hide");
                                        $(".alert-danger").addClass("show");
                                        $(".alert-success").removeClass("hide");
                                        $(".alert-success").addClass("show");
                                        self.removeAllFiles();
                                        self.categoryId = '';
                                        self.categoryArr = [];
                                        /*self.locationId = '';
                                         self.locationArr = [];
                                         self.roleId = '';
                                         self.roleArr = [];*/
                                        self.videoTitle = '';
                                        self.description = '';
                                        self.videoURL = '';
                                        self.status = {value: 'active', text: 'Active'};
                                        self.loadCategoryFirst();
                                        $("#status option[value='']").attr('selected', true);
                                        $("#type option[value='']").attr('selected', true);

                                        setTimeout(function () {
                                            $(".alert-danger").removeClass("show");
                                            $(".alert-danger").addClass("hide");
                                        }, 5000);
                                    } else {
                                        $("#addBenifitBtn").val("Save");
                                        $("#addBenifitBtn").prop("disabled", false);
                                        $("#addAndContinueBenifitBtn").prop("disabled", true);
                                        $("#CancelBenifit").prop("disabled", false);
                                        $("#errorMsg").html(err.response.data.message);
                                        $(".alert-danger").removeClass("hide");
                                        $(".alert-danger").addClass("show");
                                        setTimeout(function () {
                                            $(".alert-danger").removeClass("show");
                                            $(".alert-danger").addClass("hide");
                                        }, 5000);
                                    }

                                    if (err.response.status == 0) {
                                        self.errorMsg = "Remote server can not be reachable";
                                    } else {
                                        //redirect to login page if user not authenticated
                                        if (err.response.status == 401) {
                                            //clear previous data
                                            localStorage.removeItem("user_obj");
                                            localStorage.removeItem("api_token");
                                            localStorage.removeItem("profile_image");
                                            //EventBus.$emit("logged-in", true, "", "");
                                            self.$router.push("/login");
                                        }
                                        $("#errorMsg").html(err.response.data.message);
                                        $(".alert-danger").removeClass("hide");
                                        $(".alert-danger").addClass("show");
                                        setTimeout(function () {
                                            $(".alert-danger").removeClass("show");
                                            $(".alert-danger").addClass("hide");
                                        }, 5000);
                                    }
                                }
                                self.hideLoader();
                            });
                }

                //
            },
            formatString(data) {
                var self = this;
                var value = data.replace(/_/g, " ");
                var upp = value.toLowerCase().replace(/\b[a-z]/g, function (letter) {
                    return letter.toUpperCase();
                });
                return upp;
            },
            progressOfUload(totaluploadprogress, totalBytes, totalBytesSent) {
                if (totaluploadprogress == 100) {
                    self.fileUploaded = true;
                    self.videoURLError = "";
                } else {
                    self.fileUploaded = false;
                }
            }
        }
    }
</script>

<style>
    .disabled {
        pointer-events:none;
        color: #bfcbd9;
        cursor: not-allowed;
        background-image: none;
        background-color: #eef1f6;
        border-color: #d1dbe5;
    }
</style>



// WEBPACK FOOTER //
// src/components/backend/dayforce101/AddDayforce101.vue